var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import setIfNotSet from "@irati/utils/setIfNotSet";
import PBService from "@irati/utils/services";
import client from "@irati/utils/services/apollo";
import { DealsListType, DealStatus } from "@irati/types";
import dealService from "./dealsGraph";
import dealsErrorHandler from "./errors/dealsErrorHandler";
import createCompanyBenefitMutation, { createCompanyBenefitsKey } from "./mutations/companyBenefitCreate";
import udpateCompanyBenefitMutation, { updateCompanyBenefitsKey } from "./mutations/companyBenefitUpdate";
import archiveCompanyBenefitMutation from "./mutations/companyBenefitArchive";
var CompanyBenefitService = /** @class */ (function (_super) {
    __extends(CompanyBenefitService, _super);
    function CompanyBenefitService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = function (variables, options) {
            if (variables === void 0) { variables = {}; }
            if (options === void 0) { options = {}; }
            variables.type = DealsListType.Company;
            variables.status = DealStatus.On;
            return dealService.list(variables, options);
        };
        _this.get = function (id, options) {
            if (options === void 0) { options = {}; }
            return dealService.deal({ uuid: id, useWhitelist: true }, options);
        };
        _this.getForAdmin = function (id, options) {
            if (options === void 0) { options = {}; }
            return _this.list({ uuids: [id], ignoreBlacklist: true }, options).then(function (_a) {
                var results = _a.results;
                return results.filter(function (t) { return t.uuid === id; })[0];
            });
        };
        _this.create = function (benefit, options) {
            if (options === void 0) { options = {}; }
            var details = parseForUpdate(benefit);
            setIfNotSet(details, "type", DealsListType.Company);
            var variables = { details: details };
            return client.mutate(__assign(__assign({}, options), { mutation: createCompanyBenefitMutation, variables: variables })).then(function (_a) {
                var data = _a.data;
                return data[createCompanyBenefitsKey];
            });
        };
        _this.update = function (id, benefit, options) {
            if (options === void 0) { options = {}; }
            var details = parseForUpdate(benefit);
            var variables = { id: id, details: details };
            return client.mutate(__assign(__assign({}, options), { mutation: udpateCompanyBenefitMutation, variables: variables })).then(function (_a) {
                var data = _a.data;
                return data[updateCompanyBenefitsKey];
            });
        };
        _this.archive = function (id, options) {
            if (options === void 0) { options = {}; }
            var variables = { id: id };
            return client.mutate(__assign(__assign({}, options), { mutation: archiveCompanyBenefitMutation, variables: variables })).then(function () { return true; });
        };
        return _this;
    }
    return CompanyBenefitService;
}(PBService));
var parseForCreate = function (benefit) {
    return {
        bannerImage: benefit.bannerImage,
        cardImage: benefit.cardImage,
        contactInfo: benefit.contactInfo,
        description: benefit.description,
        header: benefit.header,
        importantInfo: benefit.importantInfo,
        locale: benefit.locale,
        redemptionInstructions: benefit.redemptionInstructions,
        savings: benefit.savings,
        status: benefit.status,
        teamIds: benefit.teamIds,
        thumbnailImage: benefit.thumbnailImage,
        type: benefit.type
    };
};
var parseForUpdate = function (benefit) {
    return __assign(__assign({}, parseForCreate(benefit)), { urlSlug: benefit.urlSlug });
};
export default new CompanyBenefitService({ errorHandlers: [dealsErrorHandler] });
